import { debug } from "console";
import * as _ from "lodash";
import { Excel, Spread } from "../../grapecity";
import * as SPIRIT from "../../SPIRIT";
import * as DATEFNS from 'date-fns';

/**
 * サマリ集計に必要なプラントID、カテゴリIDのリスト
 * */
export interface PlantCategoryList {
    PlantId: any,
    CategoryId: any
}



export interface FuncitonLockAttribute {
    lockedClass: string,
    lockingClass: string
    unLockedClass: string
}


/**
 * 業務ページ基底クラス
 */
export abstract class PageBase {

    //
    static readonly DATA_KEY = 'SPIRIT';

    //
    static readonly INSTANCE_RETAINER = '#body-container';

    /**
     * 
     */
    private promise: Promise<any>;

    /**
     * 
     */
    protected _IsInitialized: boolean = false;

    /**
     * 
     * 
     */
    $btnFuncitonLock: JQuery<HTMLElement>;


    /**/
    funcitonLockAttr: FuncitonLockAttribute = {
        lockedClass: 'btn-spirit',
        lockingClass: 'btn-secondary',
        unLockedClass: 'btn-primary'
    }

    /**
     * 初期化終了(エラーがあっても終了したらTrue)
     */
    get IsInitialized() {
        return this._IsInitialized;
    }

    /**/
    protected _isAbort = false;
    /**
     * 失敗
     */
    get isAbort() {
        return this._isAbort;
    }

    /**
     * 編集されたかどうか
     */
    public isEdited = false;

    /***/
    public functionCode: string;

    /** プロジェクトに属さないページかどうか(マスタ等)*/
    public isNoneProject: boolean;

    /***/
    public functionLockControl: SPIRIT.base.FunctionLockControl;

    /**
     * 権限による画面編集可能かどうか
     */
    get isEditable(): boolean {
        return SPIRIT.session.FuncAuth.isAllowed(this.functionCode, true);
    }

    /**
     * 準備完了(外部ハントリング用のイベント)
     * 初期化失敗時にはisAbortがTureである
     */
    public onCompleted: (page: PageBase, isAbort: boolean) => void;

    /**
     * ctor
     * @constructor
     * @param functionCode
     * @param isNoneProject
     */
    constructor(functionCode?: string, isNoneProject?: boolean) {
        this.functionCode = functionCode;
        this.isNoneProject = (isNoneProject === true) ? true : false;

        // //本来はコンストラクタでrunしたい。ただし、その実装だと、派生クラスの先頭でbase.runしなければないため、固有の引数を使って、buildすることができない
        //this.run();
    }

    /**
     * run
     */
    run() {
        console.log('====================================');
        this.promise = new Promise((resolve, reject) => {
            console.log('1 :  start!!');
            resolve();
        }).then(() => {
            console.log('2 : preProcess!!');
            return new Promise((resolve, reject) => {
                this.preProcess(resolve, reject);
            });
        }).then(() => {
            console.log('3 : initialize!!');
            return new Promise((resolve, reject) => {
                this.initialize(resolve, reject);
            });

        }).then(() => {
            console.log('4 : onReady!! (DOM created!!) ');
            return new Promise((resolve, reject) => {
                this.onReady(resolve, reject);

                ////$(function () {
                //$(() => {
                //    //resolve();
                //    this.ready(resolve, reject);
                //});

            });
        }).then(() => {
            console.log('5 : build!!');
            return new Promise((resolve, reject) => {
                this.build(resolve, reject);
            });

        }).then(() => {
            console.log('6 : setEvents!!');
            return new Promise((resolve, reject) => {
                this.setEvents(resolve, reject);
            });

        }).then(() => {
            console.log('7 : finalProcess!!');
            return new Promise((resolve, reject) => {
                this.finalProcess(resolve, reject);
            });

        }).catch((ex) => {
            this._isAbort = true;
            //TODO system Error
            //common process
            console.log('Error!!');
            if (ex instanceof Error) {
                console.log(ex.message);
            } else {
                console.log(ex);
            }

        }).finally(() => {
            //インスタンスを保持する
            this.retainInstance();
            this._IsInitialized = true;

            console.log('7 : completed');
            //準備完了
            this.completedFork();

            console.log('--------------------------');
            console.log('8 : deffereLoad!!');
            new Promise((resolve, reject) => {
                this.deffereLoad(resolve, reject);
            }).catch((ex) => {
                console.log('deffereLoad　Error!!');
                if (ex instanceof Error) {
                    console.log(ex.message);
                } else {
                    console.log(ex);
                }
            });
        });
    }



    /**
     * Base専用 前提条件（セッション、権限管理）を構築する
     * @description 
     */
    private async preProcess(resolve, reject) {

        ////waterfall
        //this.promise = new Promise((resolve, reject) => {
        //    resolve();
        //}).then((session) => {
        //    /** session情報の取得*/
        //    return this.getSession();
        //}).then((session) => {
        //    // FunctionLock情報情報の取得
        //    return this.initFunctionLock(session);
        //}).then(() => {
        //    resolve();
        //}).catch((e) => {
        //    //エラー
        //    reject();
        //});

        //pararel
        Promise.all(
            [
                this.getSession(),
                //this.initFunctionLock()//やめた最後にした（バラバラしてるのが嫌なので）
            ]
        ).then((values) => {
            //完了(成功)
            resolve();
        }).catch((e) => {
            //エラー
            reject();
        }).finally(() => {
        });
    }

    /**
     * 非同期処理、バックグランド処理なのどを行う(optional)
     *  @description  
     *  @override
     */
    //protected abstract async initialize(resolve, reject);
    //protected async initialize(resolve, reject) {
    protected initialize(resolve, reject) {
        resolve();
    }

    /**
     * ページの初期処理を担保
     * @description 
     */
    private onReady(resolve, reject) {
        //$(function () {
        $(() => {
            //起動タイミングをずらす（spread等のエレメントが出来てない為）
            //    this.readyFunctionLockControl().then(() => {
            //        //resolve();
            //        this.ready(resolve, reject);
            //    });

            //resolve();
            this.ready(resolve, reject);
        });
    };

    /**
     * Domのreadyのタイミング(optional)
     * @description 
     *  @override
     */
    //protected async ready(resolve, reject) {
    protected ready(resolve, reject) {
        resolve();
    };

    /**
     * ページの初期処理(required)
     * @description 
     * @abstract
     */
    protected abstract async build(resolve, reject);

    /**
     * 画面項目のイベントをバインドする(optional)
     * @description   
     * @override
     */
    //protected abstract setEvents(resolve, reject);
    //protected abstract async setEvents(resolve, reject);
    //protected async setEvents(resolve, reject) {
    protected setEvents(resolve, reject) {
        resolve();
    }

    /**
     *  条件（セッション、権限管理）を構築する
     * @description 
     */
    protected async finalProcess(resolve, reject) {
        //#4085

        ////機能ロック（全てこのタイミングシーケンスの一番最後）
        //this.initFunctionLock().then(() => {
        //    this.readyFunctionLockControl().then(() => {
        //        resolve();
        //    });
        //});

        //debugger;
        //機能ロック（全てこのタイミングシーケンスの一番最後）
        this.readyFunctionLockControl().then((res) => {
            if (res == "done") {
                this.initFunctionLock().then(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    /**
     * 遅延処理などを実行する
     * 画面のメインの制御とは関係しない、MashUpコンテンツ等ののレンダリングに使用する
     * 全てのライフサイクルが最後に実施されます
     * @description   
     * @override
     */
    protected deffereLoad(resolve, reject) {
        resolve();
    }

    /**
    * 準備完了
    */
    private completedFork() {
        //準備完了
        this.completed();
        // 準備完了(外部ハントリング用のイベント)
        if (this.onCompleted) {
            this.onCompleted(this, this.isAbort);
        }

        //#3269 usually call
        $(PageBase.INSTANCE_RETAINER).trigger('completed.spirit.pageBase', { page: this });
    };

    /**
    * 準備完了
    */
    protected completed() { };


    /**
     * インスタンスを保持する
     */
    retainInstance() {

        //debugger
        //console.log(this instanceof PageBase);

        let RETAINER: JQuery<any> = $(PageBase.INSTANCE_RETAINER);
        if (RETAINER.length == 0) {
            RETAINER = $(document);
        }
        RETAINER.data(PageBase.DATA_KEY, this);
    }

    /**
     * @description  
     */
    destroy() {
        let RETAINER: JQuery<any> = $(PageBase.INSTANCE_RETAINER);
        if (RETAINER.length == 0) {
            RETAINER = $(document);
        }
        RETAINER.data(PageBase.DATA_KEY, null);
    }

    /**
     * session情報の取得
     * (これは保険！DOMの準備が出来てない場合SPIRIT.sessionの値が取得できない場合を考慮!)
     */
    private async getSession() {
        return new Promise((resolve, reject) => {
            SPIRIT.util.getData('/CommonAPI/GetSessionInfo').
                then((source) => {
                    console.log('----Sessions----');
                    //{ UserInfo = userInfo, ProjectInfo = projectInfo, FunctionAuthorities = functionAuthorities });
                    //console.log(source);
                    //
                    SPIRIT.session.setLoginUserInfo(source?.UserInfo);
                    //SPIRIT.session.setProjectInfo(source?.ProjectInfo);
                    SPIRIT.session.setFunctionAuthorities(source?.FunctionAuthorities);

                    ////管理者HOMEからのマスタ系は空です。
                    ////というか、マスタ系は空にすべき(historybackバックで、Home/Indexのアクションにリクエストが来ないケースがありその場合セッションにプロジェクト情報が残ってしまっている)
                    //if (this.isNoneProject) {
                    //    //仮に入っていても、空にする
                    //    SPIRIT.session.setProjectInfo(null);
                    //}

                    resolve(source);
                });
        });
    }

    /**
     * FunctionLock情報情報の取得
     * @param session?{ UserInfo = userInfo, ProjectInfo = projectInfo, FunctionAuthorities = functionAuthorities });
     */
    protected async initFunctionLock() {
        return new Promise((resolve, reject) => {

            var loginUserInfo = SPIRIT.session.loginUserInfo;
            var userId = loginUserInfo.UserId;

            var projectInfo = SPIRIT.project.projectInfo;
            var projectId = projectInfo?.ProjectId;

            //管理者HOMEからのマスタ系は空です。
            //というか、マスタ系は空にすべき
            if (this.isNoneProject) {
                //仮に入っていても、空にする
                projectId = null;
            }


            this.functionLockControl = new SPIRIT.base.FunctionLockControl(userId, this.functionCode, projectId);
            this.functionLockControl.onStart = this.onStart.bind(this);
            this.functionLockControl.onStateChange = this.onStateChange.bind(this);
            //初期化等
            this.functionLockControl.initialize().then(r => {

                //#4085
                //resolve();
                //始動する
                this.functionLockControl?.start().then(() => {
                    resolve();
                });
            })
        });
    }

    /** 
     *機能ロックを準備する
     */
    protected async readyFunctionLockControl(): Promise<'none' | 'done'> {
        return new Promise((resolve, reject) => {
            //ロックボタンがあればインスタンス保持
            this.$btnFuncitonLock = $('button[data-funcitonLock]');

            //ボタンが無かったら、機能しないこと（管理しない）とみなす
            if (this.$btnFuncitonLock.length === 0) {
                //なにもしない
                //resolve();
                resolve('none');
                return;
            }

            this.$btnFuncitonLock?.on('click', () => { this.btnFuncitonLockClick(); });

            //#4085
            //if (this.functionLockControl) {
            //    this.functionLockControl?.start().then(() => {
            //        resolve();
            //    })
            //} else {
            //    resolve();
            //}

            resolve('done');

        });
    }

    /** */
    private btnFuncitonLockClick() {

        //#3887
        //if (this.functionLockControl.IsLockedSelf) {
        //    this.functionLockControl.doFunctionUnLock().then((ret: any) => {
        //        // ロック解除しました。'
        //        SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00004), { position: 'bottom right' });
        //    });
        //    //!!!!他のユーザーがロックしている場合!!!!
        //    //※一応ロック取得にチャレンジする（解除されてるかもしれない為）
        //    //解除されていたらロックする（通常のロック処理を同じことをする）
        //    //} else if (this.functionLockControl.IsLockedOthers) {
        //    //// '他ユーザ（{0} さん）が編集中のため、ロックできません。'
        //    //SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00008, [this.functionLockControl.FunctionLockInfo.LockUserName]), { position: 'bottom right' });
        //} else {
        //    //#1288 
        //    //this.functionLockControl.doFunctionLock();
        //    this.functionLockControl.doFunctionLock().then((ret: any) => {
        //        if (ret.Data && ret.Data?.Status === 'Error') {
        //            // '他ユーザ（{0} さん）が編集中のため、ロックできません。'
        //            SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00008, [ret.Data?.FunctionLockInfo?.LockUserName]), { position: 'bottom right' });
        //        } else {
        //            // 'ロックしました。'
        //            SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00003), { position: 'bottom right' });
        //            ////ロック開始直後最新の直後最新のデータを取得するか確認し、取得するとした場合各画面にreload命令を通知する
        //            ////現在編集されているかのダイアログは出さない。どのみち無効だから（ロック取得前の編集は編集とみなさない）
        //            ////ユーザーにどちらかを選ばせる
        //            //SPIRIT.dialog.ConfirmDialog('最新のデータを取得しますか?', '※編集されている内容は破棄されます。', (result => {
        //            //    if (result === 'ok') {
        //            //        //リロードの要請をする
        //            //        this.onFunctionLockedReloadNotify();
        //            //    }
        //            //}));
        //            //常にリロードの要請をする
        //            this.onFunctionLockedReloadNotify();
        //        }
        //    });
        //}


        //他のユーザーがロックしているかどうかはロック使用としたときに確認しに行くので、条件としてはこれで良しとする
        //if (this.functionLockControl.IsLocked) {
        if (this.functionLockControl.IsLockedSelf) {
            this.functionUnLock();
        }
        //（なぜこうしたか記憶に無い...恐らくリアルタイム性を考慮した結果だと思われる）
        //} else if (this.functionLockControl.IsLockedOthers) {
        //    //!!!!他のユーザーがロックしている場合!!!!
        //    //※一応ロック取得にチャレンジする（解除されてるかもしれない為）
        //    //解除されていたらロックする（通常のロック処理を同じことをする）
        //    // '他ユーザ（{0} さん）が編集中のため、ロックできません。'
        //    SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00008, [this.functionLockControl.FunctionLockInfo.LockUserName]), { position: 'bottom right' });
        //}
        else {

            //#3811 基本ロック中はGridを触れなくなった為、最新を取得する必要がなくなったが、他のユーザーが更新をしたかもしれないので、ロックしたら最新の情報にする!!
            //this.functionLock(false);
            this.functionLock();
        }
    }

    /**
     * 機能ロックを掛ける
     * @param reload
     */
    protected async functionLock(reload: boolean = true) {

        return new Promise((resolve, reject) => {
            //if (!this.functionLockControl.IsLocked) {
            if (!this.functionLockControl.IsLockedSelf) {
                //#1288 
                //this.functionLockControl.doFunctionLock();
                this.functionLockControl.doFunctionLock().then((ret: any) => {

                    if (_.isNil(ret)) {
                        resolve();
                        return;
                    }

                    if (ret.Data && ret.Data?.Status === 'Error') {
                        // '他ユーザ（{0} さん）が編集中のため、ロックできません。'
                        //#4085 抽象的な名称に変更
                        //SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00005, [ret.Data?.FunctionLockInfo?.LockUserName]), { position: 'bottom right' });
                        SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00005, [ret.Data?.LockInfo?.LockUserName]), { position: 'bottom right' });

                    } else {
                        // 'ロックしました。'
                        SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00003), { position: 'bottom right' });


                        ////ロック開始直後最新の直後最新のデータを取得するか確認し、取得するとした場合各画面にreload命令を通知する
                        ////現在編集されているかのダイアログは出さない。どのみち無効だから（ロック取得前の編集は編集とみなさない）
                        ////ユーザーにどちらかを選ばせる
                        //SPIRIT.dialog.ConfirmDialog('最新のデータを取得しますか?', '※編集されている内容は破棄されます。', (result => {
                        //    if (result === 'ok') {
                        //        //リロードの要請をする
                        //        this.onFunctionLockedReloadNotify();
                        //    }
                        //}));

                        if (reload === true) {
                            //常にリロードの要請をする
                            this.onFunctionLockedReloadNotify();
                        }
                    }
                    //
                    resolve();
                });
            } else {
                resolve();
            }
        });

    };

    /**
     * 機能ロック解除
     * @param reload
     */
    protected async functionUnLock(reload: boolean = true) {

        return new Promise((resolve, reject) => {

            if (this.functionLockControl.IsLocked) {
                //自分自身が
                if (this.functionLockControl.IsLockedSelf) {
                    //#3887 1．編集中ロック解除の場合は確認する
                    SPIRIT.business.page.confirmClose((result) => {
                        if (result === 'ok') {
                            this.functionLockControl.doFunctionUnLock().then((ret: any) => {
                                // ロック解除しました。'
                                SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00004), { position: 'bottom right' });
                                if (reload === true) {
                                    //編集済みで、ロック解除の際はリロードする
                                    this.onFunctionLockedReloadNotify();
                                }
                                //
                                resolve();
                            });
                        } else {
                            //
                            resolve();
                        }
                    });
                    //} else if (this.functionLockControl.IsLockedOthers) {
                    //!!!!他のユーザーがロックしている場合!!!!
                    //※一応ロック取得にチャレンジする（解除されてるかもしれない為）
                    //解除されていたらロックする（通常のロック処理を同じことをする）
                    //// '他ユーザ（{0} さん）が編集中のため、ロックできません。'
                    //SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00008, [this.functionLockControl.FunctionLockInfo.LockUserName]), { position: 'bottom right' });
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        });
    };



    /** */
    private functionLockButtonState() {

        if (this.$btnFuncitonLock.length > 0) {
            var icon = this.$btnFuncitonLock.find('i.material-icons');
            var textSpan = icon.siblings('span');


            //this.$btnFuncitonLock.removeClass('btn-primary btn-secondary btn-spirit');
            this.$btnFuncitonLock.removeClass(this.funcitonLockAttr.lockedClass + ' ' + this.funcitonLockAttr.lockingClass + ' ' + this.funcitonLockAttr.unLockedClass);

            if (this.functionLockControl.IsLockedSelf) {
                icon.text('lock_open');
                textSpan.text('解除');
                this.$btnFuncitonLock.attr('title', 'ロック解除');
                this.$btnFuncitonLock.attr('data-lockAction', 'lock');
                //this.$btnFuncitonLock.addClass('btn-spirit');
                if (this.funcitonLockAttr.lockedClass) {
                    this.$btnFuncitonLock.addClass(this.funcitonLockAttr.lockedClass);
                }
            } else if (this.functionLockControl.IsLockedOthers) {
                icon.text('lock_clock');
                textSpan.text('ロック中');
                this.$btnFuncitonLock.attr('title', 'ロック解除できません');
                this.$btnFuncitonLock.attr('data-lockAction', 'invalid');
                //this.$btnFuncitonLock.addClass('btn-secondary');
                if (this.funcitonLockAttr.lockingClass) {
                    this.$btnFuncitonLock.addClass(this.funcitonLockAttr.lockingClass);
                }


            } else {
                icon.text('lock');
                textSpan.text('ロック');
                this.$btnFuncitonLock.attr('title', 'ロック');
                this.$btnFuncitonLock.attr('data-lockAction', 'unlock');
                //this.$btnFuncitonLock.addClass('btn-primary');
                if (this.funcitonLockAttr.unLockedClass) {
                    this.$btnFuncitonLock.addClass(this.funcitonLockAttr.unLockedClass);
                }

            }
        }
    };

    /** */
    protected onStart() {
        this.functionLockButtonState();
        //子クラスで変更通知を受け取る
        this.onFunctionLockStateChanged(this.functionLockControl.IsLockedSelf, this.functionLockControl.IsLockedOthers);
    };

    /** */
    protected onStateChange(state: 'locked' | 'unlocked' | 'timeout') {
        this.functionLockControl.reload().then(() => {
            if (state === 'locked') {
                //このパターンは基本ない（他人がロックしている場合は解除監視を行ので、起動時にロック掛かってない場合は監視しないので...）
                // ロックされました。'
                SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00005), { position: 'bottom right' });
            }
            else if (state === 'unlocked') {
                // ロック解除されました。'
                SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00006), { position: 'bottom right' });
            }
            else {
                // タイムアウト。ロック解除されました。'
                SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00007), { position: 'bottom right' });
            }
        });
    };

    /**
     * 機能ロック時のリロード要請(#1288)
     * overrides!
     */
    protected onFunctionLockedReloadNotify() {
        //noop（override）
    };

    /** 
     * overrides!
     */
    protected onFunctionLockStateChanged(isLockedSelf: boolean, isLockedOthers: boolean) {
        //noop
    };
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * サーバー側バリデーション結果をもとに
     * 入力エラー一覧に渡すエラー情報リストを生成して返却
     * @param errors サーバー側から返却されたエラー情報
     * @param spreadInfoList Spread情報リスト
     */
    protected createErrorInfoListForServerValidation(errors, spreadInfoList: Array<SPIRIT.interfaces.SpreadInfo>): Array<SPIRIT.interfaces.IErrorInfo> {

        const errorInfoList: Array<SPIRIT.interfaces.IErrorInfo> = [];

        // 背景色を設定しないので廃止！！！
        //const spreadOrder = {};

        //// spread描画停止
        //spreadInfoList.forEach((spreadInfo, index) => {
        //    spreadInfo.spread.suspendPaint();
        //    spreadOrder[spreadInfo.spreadName] = index;
        //});

        // エラー情報解析
        errors.forEach(error => {

            // サーバーで検証したフィールド
            // List<Class>の場合、Listのフィールド名[index].クラスのフィールド名になる
            const key = error.Key;
            const visualIndex = error.VisualIndex;

            // Listのフィールド名をspread情報のkeyとする
            const spreadKey = key.substring(0, key.indexOf('['));
            // Classのフィールド名を属性名とする
            const propertyName = key.slice(key.indexOf('.') + 1);
            // サーバーで検知したエラーメッセージ（フィールドに複数エラーがある可能性がある）
            const errorMessages = error.ErrorMessages.join(' / ');
            // 上記のkeyから[]を取得する
            const myRe = /\[([^\[\]\s　]+)/g;
            const myArray = myRe.exec(key);

            // keyに配列識別子が含まれるか確認
            if (myArray != null) {
                // 配列の場合

                // 一覧入力データと仮定してSpread情報を補完する

                // 画面から渡されているspread情報とエラー情報を解析し、エラー一覧画面に必要な情報を設定する

                // 対象Spreadをkeyから特定
                const targetSpreadInfo = spreadInfoList.find(_ => _.spreadKey.find(s => s == spreadKey) != null);
                // 対象Spreadの列情報
                const colInfos = targetSpreadInfo.colInfos;
                // 対象Spreadの列情報から列番号を取得
                const colIndex = colInfos.findIndex(_ => _.name == propertyName);
                // 列番号が取れたか確認
                if (colIndex !== -1) {

                    // 列番号がとれた場合

                    // 列名取得
                    const colName = colInfos[colIndex].displayName;

                    // 行番号取得（上記のkeyから[]内のindexを取得する）
                    //const paramIndex = myArray[1];
                    const paramIndex = visualIndex;

                    // エラー一覧画面に必要な情報を作成
                    const errorInfo: SPIRIT.interfaces.IErrorInfo = this.createErrorInfo(targetSpreadInfo.spread, targetSpreadInfo.spreadName, parseInt(paramIndex), colIndex, colName, errorMessages);

                    //console.log(errorInfo);

                    errorInfoList.push(errorInfo);

                    // 本当は背景色は各Gridで実装してもらいたいが、
                    // エラー情報が複数Gridに及ぶため振り分けるのが面倒なため共通的にエラー背景色をここで設定する
                    // ただし、保存後のリフレッシュ等で色を戻すのは各Gridで実装すること
                    // エラー箇所の背景色設定
                    // エラー情報を解析する際に、背景色を設定するのは廃止！！！
                    // 廃止理由は、背景色をクリアする情報がない（全セルクリアしかできない）ので、
                    // エラー情報を結局Gridに渡すことになるのでそこで背景色を設定する方式にする。そうするとエラー箇所だけクリアすることもできる。
                    //errorInfo.spread.getSheet(0).getCell(errorInfo.row, errorInfo.col).backColor('lightpink');

                }

            } else {
                // 配列ではない場合

                // 何か必要か？必要になればその時に対応

            }
        });

        // 背景色を設定しないので廃止！！！
        //// spread描画再開
        //spreadInfoList.forEach(spreadInfo => {
        //    spreadInfo.spread.resumePaint();
        //});

        // 並び順を指定のSpread > 行 > 列 で並べる
        return this.sortErrorInfo(spreadInfoList, errorInfoList);
    }

    /**
     * エラー情報を作成して返却する
     * @param spread
     * @param spreadName
     * @param row
     * @param col
     * @param colName
     * @param messages
     */
    protected createErrorInfo(spread: Spread.Sheets.Workbook, spreadName, row, col, colName, messages): SPIRIT.interfaces.IErrorInfo {
        const errorInfo: SPIRIT.interfaces.IErrorInfo = {
            spread: spread,
            spreadName: spreadName,
            row: row,
            col: col,
            colName: colName,
            messages: messages
        };
        return errorInfo;
    }

    /**
     * エラー情報をソートする
     * @param spread
     * @param spreadName
     * @param row
     * @param col
     * @param colName
     * @param messages
     */
    protected sortErrorInfo(spreadInfoList: Array<SPIRIT.interfaces.SpreadInfo>, errorInfoList: Array<SPIRIT.interfaces.IErrorInfo>): Array<SPIRIT.interfaces.IErrorInfo> {

        const spreadOrder = {};

        spreadInfoList.forEach((spreadInfo, index) => {
            spreadOrder[spreadInfo.spreadName] = index;
        });

        // 並び順を指定のSpread > 行 > 列 で並べる
        errorInfoList.sort((a, b) => {

            const spreadOrderA = spreadOrder[a.spreadName];
            const spreadOrderB = spreadOrder[b.spreadName];
            const rowA = a.row;
            const rowB = b.row;
            const colA = a.col;
            const colB = b.col;

            // Spread
            if (spreadOrderA < spreadOrderB) { return -1; }
            if (spreadOrderA > spreadOrderB) { return 1; }

            // 行
            if (rowA < rowB) { return -1; }
            if (rowA > rowB) { return 1; }

            // 列
            if (colA < colB) { return -1; }
            if (colA > colB) { return 1; }

            return 0;

        });

        return errorInfoList;
    }

    /**
     * インポート用に保存データを追加、変更、削除に分ける
     * @param currentData 保存データ（現在のSpreadの状態から取得したデータ）
     * @return {Object} result
     * @return {Object} result.addData 追加データ
     * @return {Object} result.changeData 変更データ
     * @return {Object} result.deleteData 削除データ
     */
    protected getDivideImportSaveData(currentData: any[]) {

        // 追加データ抽出
        const addData = currentData.filter(e => e.ImportType == SPIRIT.codes.ImportType.ADDED.value);

        // 変更データ抽出
        const changeData = currentData.filter(e => e.ImportType == SPIRIT.codes.ImportType.EDITED.value);

        // 削除データ抽出
        const deleteData = currentData.filter(e => e.ImportType == SPIRIT.codes.ImportType.DELETED.value);

        return {
            addData: addData,
            changeData: changeData,
            deleteData: deleteData,
        };
    }

    /**
     * 保存データを追加、変更、削除に分ける
     * @param currentData 保存データ（現在のSpreadの状態から取得したデータ）
     * @param rawData オリジナルデータ（Spreadを初期表示したデータ）
     * @param idName ユニークになるIDの名称
     * @param orderChangedKey 並び替えにより変更となったデータから変更となるデータを紐づかせるIDの名称(機器情報、必須作業情報、作業情報で用いられる)
     * @return {Object} result
     * @return {Object} result.addData 追加データ
     * @return {Object} result.changeData 変更データ
     * @return {Object} result.deleteData 削除データ
     */
    protected getDivideSaveData(currentData: any[], rawData: any[], idName: string, orderChangedKey?: string) {

        // 追加データ抽出
        //const addData = currentData.filter(e => e.isBlank && (e.SectionType == SPIRIT.codes.SectionType.ADDED.value || (idName in e && e[idName] == null || e[idName] == '')));
        //const addData = currentData.filter(e => e.isBlank && e.SectionType == SPIRIT.codes.SectionType.ADDED.value);
        const addData = currentData.filter(e => e.SectionType == SPIRIT.codes.SectionType.ADDED.value);

        // 削除データを抽出する
        const currentDataIdList = _.map(currentData, idName);

        //rawDataはsaveDataと違って、DateオブジェクトをJsonConvertしていないので、ここでコンバートして、肩を合わせる
        //と同時に、そのままだと削除リストにDateオブジェクトがそのまま乗ってしまい、ISOStringとなって、サーバーでパースエラーの発生を防止する為
        //const rawDataIdList = _.map(rawData, idName);
        let _rawData = _.cloneDeep(rawData);
        //Date型をJSONで正しく扱える文字列に変換する
        SPIRIT.util.convertDateToJSON(_rawData);

        const rawDataIdList = _.map(_rawData, idName);

        // 差集合(左から右を除去)
        let deleteIdList = _.difference(rawDataIdList, currentDataIdList);

        // #4379 空白50行を削除すると空白行がdeleteIdListの中に含まれる為
        // idが存在するものを抽出する。idがnullや''空文字ではないもののみdeleteIdListに入れる
        deleteIdList = _.filter(deleteIdList, (id) => { return id });

        // 削除で投げる情報はIDのみでいい気がするけど、一旦そのまま形を返却する。
        // TODO 要検討！！！
        //const deleteData = rawData.filter(e => deleteIdList.indexOf(e[idName]) > -1);
        const deleteData = _rawData.filter(e => deleteIdList.indexOf(e[idName]) > -1);

        //debugger;
        ////下記でも良い(余計なものがない分通信は軽いかも)
        //const _deleteData = _rawData.filter(e => deleteIdList.indexOf(e[idName]) > -1);
        ////Keyのみ抽出
        ////複合Key対応して無いじゃん!!
        //const deleteData = _deleteData.map(function (v) {
        //    return { [idName]: v[idName] };
        //});

        // orderChangedKeyのリスト
        let orderChangedIdList = [];

        // 変更データ抽出
        let changeData = currentData.filter((e) => {

            if (idName in e && e[idName] != null && e[idName] != '') {
                if (e.SectionType == SPIRIT.codes.SectionType.EDITED.value) {
                    // orderChangedKeyが指定されていた場合
                    if (orderChangedKey) {
                        // 並び順の変更があったかチェック。あった場合orderChangedIdListへキーを格納する
                        const targetId = e[idName];
                        if (deleteIdList.indexOf(targetId) == -1) {
                            const target = _rawData.find(r => r[idName] == targetId);
                            if (target != null && target.OrderNo != e.OrderNo) {
                                orderChangedIdList.push(e[orderChangedKey]);
                            }
                        }
                    }
                    return true;
                } else {
                    const targetId = e[idName];
                    if (deleteIdList.indexOf(targetId) == -1) {
                        // 並び順が異なる場合を抽出
                        //const target = rawData.find(r => r[idName] == targetId);
                        const target = _rawData.find(r => r[idName] == targetId);
                        if (target != null && target.OrderNo != e.OrderNo) {
                            // orderChangedKeyが指定されていた場合
                            if (orderChangedKey) {
                                orderChangedIdList.push(e[orderChangedKey]);
                            }
                            return true;
                        }
                    }
                }
            }

            return false;
        });

        // orderChangedKeyが指定されていた場合かつorderChangedIdListが1件以上ある場合
        if (orderChangedKey && orderChangedIdList.length != 0) {
            // orderChangedKeyリストの重複を除く
            orderChangedIdList = _.uniq(orderChangedIdList);

            // orderChangedKeyに紐づくデータを全て取得
            const orderChangedData = [];
            // 画面上の追加、空白行を除いた(削除も)データを取得する。
            const targetDataList = _.filter(currentData, (c) => idName in c && c[idName] != null && c[idName] != '');
            _.forEach(targetDataList, (t) => {
                _.forEach(orderChangedIdList, (id) => {
                    if (t[orderChangedKey] == id) {
                        orderChangedData.push(t);
                    }
                });
            });

            // changeDataからorderChangedDataの差分のデータを抽出
            const differenceChangeData = _.difference(orderChangedData, changeData);
            // 差分のデータを変更リストに加える
            changeData = changeData.concat(differenceChangeData);
        }

        return {
            addData: addData,
            changeData: changeData,
            deleteData: deleteData,
        };
    }

    /**
     * インポート用のバリデーションデータ作成
     * インポート前のDBデータとインポートするデータをマージして返す（中のobjectの参照は切る）
     * ※削除データはバリデーション対象外のため削除しているので注意
     * @param saveData
     * @param beforeImportDbData
     * @param idName
     */
    getImportValidateData(saveData: any[], beforeImportDbData: any[], idName: string) {

        // 中でマージするため、参照を切るためクローン
        const cloneSaveData = _.cloneDeep(saveData);
        const cloneBeforeImportDbData = _.cloneDeep(beforeImportDbData);

        cloneSaveData.forEach((item) => {

            // マージしてしまうと、入力データか判断できないため識別子を付与
            item.isInput = true;

            if (item.ImportType == SPIRIT.codes.ImportType.ADDED.value) {

                cloneBeforeImportDbData.push(item);

            } else if (item.ImportType == SPIRIT.codes.ImportType.EDITED.value) {

                const target = cloneBeforeImportDbData.find((e: any) => e[idName] == item[idName]);
                _.assign(target, item);

            } else if (item.ImportType == SPIRIT.codes.ImportType.DELETED.value) {

                _.remove(cloneBeforeImportDbData, (e) => e[idName] == item[idName]);

            }

        });

        return cloneBeforeImportDbData;
    }

    /**
     * 表示順を設定
     * @param currentData 保存データ（現在のSpreadの状態から取得したデータ）
     * @param groupFunction グループ分けルール関数
     */
    protected setOrderNo(currentData: any[], groupFunction?) {

        //const records = [
        //    { player: 'a', team: 'red', subteam: 'A', score: 10 },
        //    { player: 'b', team: 'red', subteam: 'B', score: 3 },
        //    { player: 'c', team: 'green', subteam: 'A', score: 4 },
        //    { player: 'd', team: 'green', subteam: 'A', score: 15 },
        //    { player: 'e', team: 'green', subteam: 'B', score: 4 },
        //    { player: 'f', team: 'green', subteam: 'B', score: 15 },
        //];

        // 使用方法

        //// グループなし
        //this.setOrderNo(records);
        //console.log(records);

        //// 単数
        //this.setOrderNo(records, 'team');
        //console.log(records);

        //// 単数
        //this.setOrderNo(records, item => {
        //    return item.team;
        //});
        //console.log(records);

        //// 複数
        //this.setOrderNo(records, item => {
        //    return item.team + '#' + item.subteam;
        //});
        //console.log(records);

        if (groupFunction != null) {

            const groups = _.groupBy(currentData, groupFunction);

            _.forEach(groups, (arr: any[]) => {
                let orderNo = 1;
                _.forEach(arr, (item) => {
                    item.OrderNo = orderNo;
                    orderNo++;
                });
            });

        } else {

            let orderNo = 1;
            _.forEach(currentData, (item) => {
                item.OrderNo = orderNo;
                orderNo++;
            });

        }

    }

    /**
     * 空行で入力されていない行を除外した配列を返却する
     * @param data
     */
    excludeBlankRowNotInput(data: any[]) {

        // TODO 条件やプロパティ名が変わる可能性あり

        return data.filter((item) => {

            // デフォルト空行ではないものを拾う
            if (!item.isBlank) {
                return true;
            }

            // 区分列に値が入っている場合を拾う
            if (item.SectionType) {
                return true;
            }

            return false;
        });
    }

    /**
     * エクセルエクスポート
     * @param fileName
     * @param json
     * @param viewName
     */
    exportExcel(fileName: string, json, viewName: string) {
        const excelIo = new Excel.IO();
        excelIo.save(json, (blob) => {
            saveAs(blob, fileName);
            this.exportExcelLog(fileName, viewName);
        }, (e) => {
            SPIRIT.notify.error(SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00019));
            //console.log(e);
        });
    }


    /**
     * エクセルエクスポート時のログ登録
     * @param fileName
     * @param viewName
     */
    exportExcelLog(fileName: string, viewName: string) {
        // ajaxでログコントローラに非同期通信

        const message = viewName + ':' + fileName;

        const data = {
            message: message,
        };

        SPIRIT.util.ajax({
            url: '/LogInfo/ExportExcelLog',
            type: 'POST',
            data: data
        });
    }

    /**
     * サマリ集計に必要なプラントID、カテゴリIDをリストに詰める処理
     * 対象画面：機器工事情報、必須作業情報、作業情報
     * @param plantCategoryList
     * @param targetData
     */
    protected setPlantCategoryList(plantCategoryList: PlantCategoryList[], targetData) {

        // 重複しないように存在チェック
        const doExistPlantCategoryList = plantCategoryList.find(_ => _.PlantId == targetData.PlantId && _.CategoryId == targetData.CategoryId);

        // 変更後のデータのプラントID、カテゴリIDを詰める
        if (!doExistPlantCategoryList && targetData.PlantId != null && targetData.CategoryId != null) {
            plantCategoryList.push({
                PlantId: targetData.PlantId,
                CategoryId: targetData.CategoryId
            });
        }
    }

    /**
     * 指定されたプロパティの値をtrimする
     * @param array
     * @param targetPropertyNameList
     */
    doTrimValue(array: any[], targetPropertyNameList: string[]) {

        const result = _.cloneDeep(array);

        targetPropertyNameList.forEach((propertyName) => {
            result.forEach((item) => {
                if (item[propertyName] && typeof item[propertyName] === 'string') {
                    item[propertyName] = item[propertyName].trim();
                }
            });
        });

        return result;
    }

    /**
     * プロジェクト期間内かどうか
     * @param value
     */
    protected isProjectWithinInterval(value) {
        return DATEFNS.isWithinInterval(new Date(SPIRIT.util.date.getYYYYMMDD(value, true)), { start: new Date(SPIRIT.util.date.getYYYYMMDD(SPIRIT.project.projectInfo.ProjectStartDate, true)), end: new Date(SPIRIT.util.date.getYYYYMMDD(SPIRIT.project.projectInfo.ProjectEndDate, true)) });
    }

    /**
     * インポートの並び順にリストを並べ替える
     * @param list
     * @param orderNoKey
     * @param isOrderKeyNullCheck
     * @param isValidate
     */
    protected doSortList(list: any[], orderNoKey: string, beforeDataList:any[], id: string, isValidate: boolean = false) {

        // インポートで追加、変更のあったリストを取得する
        const importChangeOrInsertList = list.filter(_ => _.ImportType == SPIRIT.codes.ImportType.ADDED.value || _.ImportType == SPIRIT.codes.ImportType.EDITED.value);

        let keyList = _.uniq(_.map(importChangeOrInsertList, orderNoKey));

        keyList.forEach((keyValue) => {

            // キー単位のリストを取得する
            const targetKeyList = list.filter(_ => _[orderNoKey] == keyValue);

            // 並び順が設定されているかどうか
            //const isSetOrderNo = targetKeyList.filter(_ => _.ImportOrderNo != null && _.isInput);

            let isSetOrderNoFlag = false;

            // #4971 保守 並び順が入力かつ、変更されていたら並び順を設定する
            for (let target of targetKeyList) {
                const beforeData = beforeDataList.find(b => b[id] == target[id])
                if (target.ImportOrderNo != null && target.isInput && target.ImportOrderNo != beforeData?.ImportOrderNo) {
                    isSetOrderNoFlag = true;
                }
            }

            // 設定されている場合、並び順に並び替える
            if (isSetOrderNoFlag) {

                let index = list.findIndex(_ => _[orderNoKey] == keyValue);

                // 全体から対象のリストを抜く
                list = _.difference(list, targetKeyList);

                // 並び順に設定されているリストを抜き出す
                let isChangeOrInsertList = targetKeyList.filter(_ => _.ImportOrderNo != null && (_.ImportType == SPIRIT.codes.ImportType.ADDED.value || _.ImportType == SPIRIT.codes.ImportType.EDITED.value));
                isChangeOrInsertList = _.sortBy(isChangeOrInsertList, 'ImportOrderNo');                

                // 並び替えを設定していないリストを抜き出す
                const setOrderNoList = _.difference(targetKeyList, isChangeOrInsertList);

                let orderNoList = _.map(isChangeOrInsertList, 'ImportOrderNo');

                let firstOrderNo = orderNoList.reduce((a, b) => Math.min(a, b)) - 1;

                // 並び替えを設定していないリストに並び替えを設定したデータを入れていく
                for (let data of isChangeOrInsertList) {
                    setOrderNoList.splice(firstOrderNo, 0, data);
                    firstOrderNo++;
                }

                const isNotChangeList = setOrderNoList.filter(e => e.ImportType == null);

                // 並び替えによって変更になったデータを更新対象に入れる⇒バリデーションチェック(作業情報)の場合はこの処理はしない
                if (!isValidate) {
                    isNotChangeList.forEach(item => {
                        item.ImportType = SPIRIT.codes.ImportType.EDITED.value;
                    });
                }

                // 対象のリストを全体のリストへ入れる
                for (let data of setOrderNoList) {
                    list.splice(index, 0, data);
                    index++;
                }
            }
        });
        return list;
    }

    /**
     * インポート並び順のバリデーションチェック
     * @param spreadInfo
     * @param inputData
     * @param orderNoKey
     * @param beforeDataList 変更前データリスト
     * @param id 主キー 作業情報ならWorkId、機器工事情報ならEquipmentId
     */
    protected doValidateImportOrderNo(spreadInfo: SPIRIT.interfaces.SpreadInfo, inputData: any[], orderNoKey: string, beforeDataList: any[], id: string): Array<SPIRIT.interfaces.IErrorInfo>{

        // エラー一覧を格納するリスト
        const errorInfoList: Array<SPIRIT.interfaces.IErrorInfo> = [];

        const importOrderNoColIndex = spreadInfo.colInfos.findIndex(_ => _.name == 'ImportOrderNo');
        const importOrderNoIndexColName = spreadInfo.colInfos[importOrderNoColIndex].displayName;

        // 更新、追加データ取得
        const isChangeOrInsertDataList = inputData.filter(_ => _.ImportType == SPIRIT.codes.ImportType.ADDED.value || _.ImportType == SPIRIT.codes.ImportType.EDITED.value);

        // 並び順が入力されていた場合⇒これをチェックする
        const isExistedImportOrderNoList = isChangeOrInsertDataList.filter(d => !_.isNil(d.ImportOrderNo));

        // 数値以外が入力されていた場合
        const isNotNumberImportOrderNoList = isExistedImportOrderNoList.filter(d => !_.isNumber(d.ImportOrderNo));
        isNotNumberImportOrderNoList.forEach((item) => {
            const errorInfo = this.createErrorInfo(spreadInfo.spread, spreadInfo.spreadName, item.VisualIndex, importOrderNoColIndex, importOrderNoIndexColName, SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00015, [importOrderNoIndexColName, '半角数字']));
            errorInfoList.push(errorInfo);
        });

        // 数値が入力されているリスト
        const isNumberImportOrderNoList = _.difference(isExistedImportOrderNoList, isNotNumberImportOrderNoList);

        // 整数以外が入力されていた場合
        const isNotIsIntegerImportOrderNoList = isNumberImportOrderNoList.filter(d => d.ImportOrderNo < 1 || !_.isInteger(d.ImportOrderNo));
        isNotIsIntegerImportOrderNoList.forEach((item) => {
            const errorInfo = this.createErrorInfo(spreadInfo.spread, spreadInfo.spreadName, item.VisualIndex, importOrderNoColIndex, importOrderNoIndexColName, SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00043, ['1']));
            errorInfoList.push(errorInfo);
        });

        // 整数で入力されているもの
        const isIntegerImportOrderNoList = _.difference(isNumberImportOrderNoList, isNotIsIntegerImportOrderNoList);

        // キー単位毎でチェック(機器工事情報、作業情報ではPlantCategoryCompanyId、キーが無いものはProjectIdで良いかと思われる)
        const orderNoKeyImportOrderNoList = _.uniq(_.map(isIntegerImportOrderNoList, orderNoKey));

        orderNoKeyImportOrderNoList.forEach(targetKey => {

            // キー単位でリスト数以上の数値の入力不可
            const keyDataList = inputData.filter(_ => _[orderNoKey] == targetKey);

            const isOrverImportOrderNoList = isNumberImportOrderNoList.filter(_ => _[orderNoKey] == targetKey && _.ImportOrderNo > keyDataList.length);
            isOrverImportOrderNoList.forEach((item) => {
                const errorInfo = this.createErrorInfo(spreadInfo.spread, spreadInfo.spreadName, item.VisualIndex, importOrderNoColIndex, importOrderNoIndexColName, SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00101, [importOrderNoIndexColName, keyDataList.length]));
                errorInfoList.push(errorInfo);
            });

            // 重複がないかチェック
            let isCheckImportOrderNoList = isIntegerImportOrderNoList.filter(_ => _[orderNoKey] == targetKey);
            isCheckImportOrderNoList = _.difference(isCheckImportOrderNoList, isOrverImportOrderNoList);

            const importOrderNoList = _.map(isCheckImportOrderNoList, 'ImportOrderNo');
            const diplicateImportOrderNoData = _.uniq(_.filter(importOrderNoList, (val, i, iteratee) => _.includes(iteratee, val, i + 1)));
            const diplicateImportOrderNoList = isCheckImportOrderNoList.filter(item => diplicateImportOrderNoData.indexOf(item.ImportOrderNo) > -1);
            diplicateImportOrderNoList.forEach((item) => {
                const errorInfo = this.createErrorInfo(spreadInfo.spread, spreadInfo.spreadName, item.VisualIndex, importOrderNoColIndex, importOrderNoIndexColName, SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00017, [importOrderNoIndexColName]));
                errorInfoList.push(errorInfo);
            });

            // 並び順でここまでエラーが無かった場合
            if (diplicateImportOrderNoList.length == 0 && isOrverImportOrderNoList.length == 0) {

                // 連番になっているかチェック(飛び番になってたらエラー)
                let isSerialOrderNoList = _.cloneDeep(isCheckImportOrderNoList);
                isSerialOrderNoList = _.sortBy(isSerialOrderNoList, 'ImportOrderNo'); // 並び順に設定
                let orderNoList = _.map(isSerialOrderNoList, 'ImportOrderNo');
                let firstOrderNo = orderNoList.reduce((a, b) => Math.min(a, b)); //並び順の最小値を取得

                // #4971 保守 並び順に変更がない場合はエラーとしない
                // ⇒まずキー単位の中で全てチェックし、1つでも変更がないか確認する。

                let isChangeOrderNoFlag = false;

                for (var data of isSerialOrderNoList) {
                    const beforeData = beforeDataList.find(b => b[id] == data[id]);
                    if ((data.ImportType == SPIRIT.codes.ImportType.EDITED.value && data.ImportOrderNo != beforeData?.ImportOrderNo)
                        || (data.ImportType == SPIRIT.codes.ImportType.ADDED.value && !_.isNil(data.ImportOrderNo))) {
                        isChangeOrderNoFlag = true;
                        break;
                    }
                }

                // 変更があった場合のみ、連番チェックする
                if (isChangeOrderNoFlag) {

                    let isNotSerial = false;

                    // 並び順を一つずつ回し、連番になっているか
                    for (var data of isSerialOrderNoList) {
                        if (data.ImportOrderNo != firstOrderNo) {
                            isNotSerial = true;
                            break;
                        }
                        firstOrderNo++;
                    }

                    if (isNotSerial) {
                        isCheckImportOrderNoList.forEach((item) => {
                            const errorInfo = this.createErrorInfo(spreadInfo.spread, spreadInfo.spreadName, item.VisualIndex, importOrderNoColIndex, importOrderNoIndexColName, SPIRIT.util.getMessage(SPIRIT.message.MSG_E_00015, [importOrderNoIndexColName, '連番']));
                            errorInfoList.push(errorInfo);
                        });
                    }
                }
            }
        });
        return errorInfoList;
    }

}




